const cartesian = (...args) => args.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));
export default cartesian;
